import React from "react";
import {
  PhoneOutlined,
  VideoCameraFilled,
} from "@ant-design/icons";
import { IoChatbubbles } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import doc from "../../assets/images/user.png";

type ApptCardProps = { data: any };

export default function ApptCard({ data }: ApptCardProps) {
  const navigate = useNavigate();

  const typeIcon =
    data.appointmentType === "video" ? (
      <VideoCameraFilled className="text-primary-blue" aria-hidden />
    ) : data.appointmentType === "voice" ? (
      <PhoneOutlined className="text-primary-blue" aria-hidden />
    ) : data.appointmentType === "chat" ? (
      <IoChatbubbles className="text-primary-blue" aria-hidden />
    ) : null;

  return (
    <button
      type="button"
      onClick={() => navigate(`/appointments/${data.id}`)}
      className="flex w-full items-center gap-4 rounded-xl border border-slate-200/80 bg-white p-3 text-left shadow-card transition-all hover:border-primary-blue/30 hover:shadow-card-hover focus:outline-none focus:ring-2 focus:ring-primary-blue/40"
      aria-label={`View appointment with ${data.patientName ?? "patient"} on ${moment(data.date, "DD-MM-YYYY").format("Do MMMM YYYY")}`}
    >
      <div className="flex shrink-0 flex-col items-center justify-center rounded-lg bg-gradient-to-br from-primary to-primary-blue px-3 py-2 text-white">
        <span className="text-xs font-medium leading-tight">
          {data.startTime}
        </span>
        <span className="text-[10px] opacity-90">–</span>
        <span className="text-xs font-medium leading-tight">
          {data.endTime}
        </span>
      </div>

      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="relative h-12 w-12 shrink-0 overflow-hidden rounded-full bg-slate-100">
          <img
            src={data.user?.picture ?? doc}
            alt=""
            className="h-full w-full object-cover"
          />
        </div>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold text-slate-800">
            {data.patientName ?? data.user?.fullname ?? "Patient"}
          </p>
          <p className="text-xs text-slate-500">
            {moment(data.date, "DD-MM-YYYY").format("Do MMMM, YYYY")}
          </p>
          {typeIcon && (
            <span className="mt-0.5 flex items-center gap-1 text-xs text-primary-blue">
              {typeIcon}
              <span className="capitalize">{data.appointmentType}</span>
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
